













































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwActionBar, SwActionBarItem } from '@libs-uuif/shared/sw-action-bar';
import { SwTabGroup, SwTabPage, TabProps } from '@libs-uuif/shared/sw-tab-layout';
import { SwModal, SwModalBody, SwModalFooter } from '@libs-uuif/shared/sw-modal';
import {
  insertWidgetTabsProps,
  widgetProduct,
  widgetDataGroup,
} from './insert-widget-constants';
import { SwButton } from '@libs-uuif/shared/sw-button';
import InsertWidgetFields from './insert-widget-fields.vue';
import { UnifiedInsightsStoreState } from '../unified-insights.store';
import { Mutation, namespace, State } from 'vuex-class';
import { CoreStoreState } from '@/core';
import { RootStoreState } from '@/store';
import { VuexMappedMutation } from '@sonicwall/unified-ui-framework/src/shared/common-types';
import { nsmApiService } from '@/shared/api-service/nsm-api-service';
const cssPrefix = 'insert-widget-modal';
const unifiedInsightsStoreModule = namespace('UnifiedInsightsStoreModule');

@Component({
  components: {
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwActionBar,
    SwActionBarItem,
    SwTabGroup,
    SwTabPage,
    InsertWidgetFields,
  },
})
export default class InsertWidgetModal extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @unifiedInsightsStoreModule.State
  widgets: UnifiedInsightsStoreState['widgets'];

  @State((state: RootStoreState) => state.CoreStoreModule.productList)
  productList: CoreStoreState['productList'];

  @Mutation
  setTenantGroups: VuexMappedMutation<CoreStoreState['tenantGroups']>;

  @Prop({ required: true })
  onCloseModal: any;

  @Prop({ required: true, type: Boolean, default: false })
  showModal: boolean;

  @Prop({ required: false, type: String, default: 'New Widget' })
  modalTitle: string;

  @Prop({ required: false, type: Number, default: null })
  selectedWidgetIndex: number;

  modalWidth: string = '641px';
  widgetProduct: any = widgetProduct;
  widgetDataGroup: any = widgetDataGroup;

  disableSaveButton: boolean = true;
  selectedTabId: string = insertWidgetTabsProps[0].tabId;
  tabsProps = insertWidgetTabsProps;
  isMounted: boolean = false;
  tabChanged: Boolean = false;

  /**
   * @desc This function will be called whenever the value of the dependency changes
   */
  @Watch('selectedTabId', {})
  selectedTabChanged() {
    if (this.isMounted) {
      this.tabChanged = true;
    }
  }

  /**
   * @desc This function will be called every time before updating the component
   */
  beforeUpdate() {
    this.isMounted = true;
  }

  /**
   * @desc This function will be called when the user clicks on the save button of the widget insert modal.
   */
  onSaveClicked() {
    const el: any = this.$refs.wigetInputFields as HTMLElement;
    el.length > 0 && el[0].onSave();
  }

  widgetAdded() {
    this.$emit('widgetAdded');
  }

  /**
   * @desc This function will be called on component mount
   */
  mounted() {
    if (this.productList.includes('NGMGMT')) {
      this.setNsmGroups();
    }
    const productDataGroupMapped: string[] = this.productList.map((product: any) => {
      if (product === 'NGMGMT') {
        return 'firewall';
      }
      if (product === 'Capture Client') {
        return 'capture client';
      }
      if (product === 'Wireless') {
        return 'wireless';
      }
      return '';
    });
    if (productDataGroupMapped.includes('wireless')) {
      productDataGroupMapped.push('switches');
    }
    this.tabsProps = this.tabsProps.map((tabProp: TabProps) => {
      if (productDataGroupMapped.includes(tabProp.tabId)) {
        return { ...tabProp, disabled: false };
      }
      return { ...tabProp, disabled: true };
    });
    if (this.selectedWidgetIndex !== null) {
      const selectedWidgetDetails: any = this.widgets[this.selectedWidgetIndex];
      this.selectedTabId = selectedWidgetDetails.dataGroup;
    } else {
      const defaultTab = this.tabsProps.find(prop => !prop.disabled);
      this.selectedTabId = defaultTab ? defaultTab.tabId : '';
    }
  }
  async setNsmGroups() {
    await nsmApiService
      .getTenantGroups()
      .then((response) => {
        const groupsData = response.map((group: any) => {
          if (group.groupID && group.friendlyName) {
            let innerGroupDevices: any = [];
            if (group.deviceGroups) {
              innerGroupDevices = this.fetchInnerDevices(
                response,
                group.deviceGroups,
                [group.groupID],
              );
            }
            const groupDevices = group.devices ? group.devices : [];
            return {
              groupId: group.groupID,
              groupName: group.friendlyName,
              devices: [...groupDevices, ...innerGroupDevices] || [],
            };
          }
        });
        this.setTenantGroups(groupsData);
      })
      .catch((error) => {
        this.setTenantGroups([]);
        console.error('NSM fetch tenant groups API error', error);
      });
  }
  fetchInnerDevices(groupsData: any, innerGroups: any, visitedGroup: any) {
    if (!innerGroups) {
      return [];
    }
    let innerGroupDevices: any = [];
    innerGroups.map((innerGroupId: any) => {
      if (visitedGroup.includes(innerGroupId)) {
        return;
      }
      const innerGroup = groupsData.find(
        (responseGroup: any) => responseGroup.groupID === innerGroupId,
      );
      innerGroup &&
      innerGroup.devices &&
      (innerGroupDevices = [...innerGroupDevices, ...innerGroup.devices]);
      innerGroup &&
      innerGroup.deviceGroups &&
      (innerGroupDevices = [
        ...innerGroupDevices,
        ...this.fetchInnerDevices(groupsData, innerGroup.deviceGroups, [...visitedGroup, innerGroupId]),
      ]);
    });
    return innerGroupDevices;
  }
}
